class QhAtvExtraFuncionario {
  constructor(dados) {
    this.idFuncionario = dados ? dados.idFuncionario : null;
    this.numeroRegistro = dados ? dados.numeroRegistro : null;
    this.nome = dados ? dados.nome : null;
    this.funcao = dados ? dados.funcao : null;
    this.participante = dados ? !!dados.participante : false;
  }
}
export default QhAtvExtraFuncionario;
